module.exports = __webpack_public_path__ + "img/118.5c2e43f5.jpg";